import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_router_view = _resolveComponent("router-view")!

  return (!_ctx.$route.params.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_row, {
          justify: "space-between",
          align: "center",
          dense: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  align: "center",
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          color: "#F4F4F4",
                          variant: "flat",
                          class: "pa-2",
                          height: "48"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              dense: "",
                              align: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  md: "8"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      align: "center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "4",
                                          md: "auto"
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_data_table, {
          "sort-by": [{key: 'name', order: 'asc'}],
          items: _ctx.nodeRedInstances,
          headers: _ctx.headers,
          "fixed-header": "",
          "return-object": "",
          height: "calc(100vh - 260px)",
          "items-per-page": "25"
        }, {
          [`item.actions`]: _withCtx(({ item }) => [
            _createVNode(_component_v_menu, null, {
              activator: _withCtx(({ props }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    size: "32",
                    icon: "",
                    variant: "flat",
                    color: "primary"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "20" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-dots-vertical")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, { density: "compact" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      to: `/admin/nodered/${item.id}`,
                      "prepend-icon": "mdi-pencil",
                      title: "Edit Node-RED instance"
                    }, null, 8, ["to"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["items", "headers"])
      ]))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}